import clsx from 'clsx';

interface DefinitionListProps {
  className?: string;
  items: Record<string, React.ReactNode>;
}

export const DefinitionList = ({ className, items }: DefinitionListProps) => (
  <dl className={clsx('grid grid-cols-2 gap-1', className)}>
    {Object.keys(items).map((label, i) => (
      <div key={i}>
        <dt className="font-bold text-xs text-green-dark bg-green-light p-2">
          {label}
        </dt>
        <dd className="text-xs text-green-dark bg-green-light p-2">
          {items[label]}
        </dd>
      </div>
    ))}
  </dl>
);
